import * as React from 'react';
import { Translate } from '../../shared/LanguageService';

interface IStatusIconsProps {
    orderStatuses: any[];
    isPlanOrder?: boolean;
    isOldEditOrder?: boolean;
}

const StatusIcons = (props: IStatusIconsProps) => {
    let visibleIcons = [
        {
            status: 1,
            icon: 'feedback',
            className: 'needs-editing'
        } /* NeedsEditing */,
        {
            status: 2,
            icon: 'comment',
            className: 'has-new-comments'
        } /* HasNewComment */,
        {
            status: 3,
            icon: 'feedback',
            className: 'returned-from-needs-editing'
        } /* ReturnedFromNeedsEditing */,
        {
            status: 4,
            icon: 'warning',
            className: 'has-failed-delivery'
        } /* DeliveryFailure */
    ];

    if (props.isPlanOrder) {
        visibleIcons = [
            {
                status: 1,
                icon: 'feedback',
                className: 'has-annotation'
            } /* HasAnnotation */,
            {
                status: 2,
                icon: 'warning',
                className: 'has-failed-delivery'
            } /* DeliveryFailure */
        ];
    }

    return (
        <span className="status-icons">
            {props.orderStatuses &&
                props.orderStatuses
                    .filter((x: any) => visibleIcons.find((p) => p.status === x.value))
                    .map((x: any) => {
                        return {
                            icon: visibleIcons.find((p) => p.status === x.value).icon,
                            className: visibleIcons.find((p) => p.status === x.value).className,
                            title: Translate(x.displayName)
                        };
                    })
                    .map((x: any, i: number) => (
                        <i title={x.title} key={i} className={'material-icons ' + x.className}>
                            {x.icon}
                        </i>
                    ))}
            {props.isOldEditOrder && (
                <i
                    title={Translate('photo/list/status/old-edit-order')}
                    className="material-icons old-edit-order"
                >
                    alarm
                </i>
            )}
        </span>
    );
};
export default StatusIcons;
